// import { keys } from "core-js/fn/object";
import React from "react";
import { Button } from "react-bootstrap";
import { INews, filterNews } from "../../news/logics/news";
import { NewsItem } from "../molecules/NewsItem";
import { NewsNotFound } from "../atoms/NewsNotFound"

interface INewsList {
  news: INews[];
  all?: boolean;
  important?: boolean;
  pinned?: boolean;
  initShowCount: number;
  setShowCount: React.Dispatch<React.SetStateAction<number>>;
  props?: any;
}

export const NewsList = ({
  news,
  initShowCount,
  setShowCount,
  all = false,
  important = false,
  pinned = false,
  props = null,
}: INewsList) => {
  const [filteredNews, setFilteredNews] = React.useState<INews[] | null>(null);
  React.useEffect(() => {
    if (filteredNews && filteredNews.length > initShowCount) {
      setFilteredNews(filteredNews.slice(0, initShowCount));
    }
    setFilteredNews(filterNews(news, all, important));
    return () => {
      setFilteredNews(null)
    }
  }, [all, important])

  return (
    <>
      {filteredNews && filteredNews.map((n: any, i: any) => (
        <NewsItem
          key={i}
          newsItem={n}
          important={n.important === 1}
          pinned={n.topPost === 1}
        ></NewsItem>
      ))}
      {filteredNews && filteredNews.length > initShowCount ? (
        <div
          style={{ minWidth: "350px", maxWidth: "600px", textAlign: "center" }}
        >
          <Button
            variant="outline-success"
            onClick={() => setShowCount(initShowCount + 1)}
          >
            Загрузить ещё
          </Button>
        </div>
      ) : (
        <></>
      )}
      {filteredNews && filteredNews.length === 0 && <NewsNotFound text="Новости не найдены" />}
    </>
  );
};
